import { PlatformIcon } from '../../../atoms/PlatformIcon/PlatformIcon';
import { platformFor } from '@deepdive-icons';
import { Drawer } from '../../../molecules/Drawer/Drawer';
import { BreakdownBody, type BreakdownView } from '../BreakdownBody/BreakdownBody';

/**
 * Competitors — `Drawer` at `Property 1=Breakdown` (2038:27494), opened by
 * `Breakdown ›` on a Top performing content row — on Competitors, both
 * Influencers detail views and any custom report carrying that table.
 *
 * **The container only.** The five widgets inside are `BreakdownBody`, shared
 * with the conversations modal's breakdown. Measured 2026-09-26: 598 x 876 at
 * (830, 12) in a 1440x900 viewport, matching the frame exactly.
 *
 * The header reads "Post breakdown" over the post's summary, with the post's
 * channel mark as the featured icon (the user's call; the frame's are
 * placeholders).
 */
export type PostBreakdownPost = {
  /** `Robi · Network coverage complaint on Facebook`. */
  summary: string;
  channel: string;
  channelLabel: string;
};

export type PostBreakdownDrawerProps = {
  open: boolean;
  onClose: () => void;
  /**
   * The post. Kept by the caller after `open` goes false, so the panel does
   * not empty out while it slides away.
   */
  post: PostBreakdownPost | null;
  /** Its breakdown, once loaded — as the dashboard counts it, corrections included. */
  view?: BreakdownView;
};

export function PostBreakdownDrawer({ open, onClose, post, view }: PostBreakdownDrawerProps) {
  /* The key on mock data, the name on live (where the key is an id). */
  const platform = post ? (platformFor(post.channel) ?? platformFor(post.channelLabel)) : undefined;

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title="Post breakdown"
      description={post?.summary}
      /* The post's own text, which can run to thousands of characters. */
      clampDescription
      icon={
        platform && post ? (
          <PlatformIcon name={platform.name} label={post.channelLabel} />
        ) : undefined
      }
    >
      {post && view && <BreakdownBody view={view} noun="post" />}
    </Drawer>
  );
}
